import { render } from "./MoveBottom.vue?vue&type=template&id=77e0deea"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/MoveBottom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77e0deea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77e0deea', __exports__)) {
    api.reload('77e0deea', __exports__)
  }
  
  module.hot.accept("./MoveBottom.vue?vue&type=template&id=77e0deea", () => {
    api.rerender('77e0deea', render)
  })

}


export default __exports__